export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "SBI Home Loan EMI Calculator: Plan Your Home Loan Repayments with Ease",
    subHeading:
      "Use SBI’s Home Loan EMI Calculator to estimate your monthly loan installments, repayment schedule, and total interest payable. By using this free tool, you can plan your finances effectively and ensure that your home loan remains manageable throughout its tenure.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
